export { SearchPivotsContainer } from './SearchPivotsContainer';
